import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { deleteTemplateGroup } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function removeTemplateGroup({
  accountId,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(deleteTemplateGroup(accountId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'Content-type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  params: {
    Title: string;
    Container: string;
  };
};

type TSnapshot = unknown;

function useDeleteTemplateGroup(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ accountId, params }: TVariables) => {
    const { Container } = params;
    const result = await removeTemplateGroup({ accountId, params });
    if (result.Data) {
      if (Container === 'layouts') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'layouts'],
          {
            refetchInactive: true,
          },
        );
      } else if (Container === 'tables') {
        queryClient.invalidateQueries(
          ['getExistingTemplates', true, accountId, 'tables'],
          {
            refetchInactive: true,
          },
        );
      }
    } else if (result.Errors) throw result;
    return result;
  });
}

export { useDeleteTemplateGroup };
